import api from "./api";
import { parsePaginatedList, asList } from "../utils/pagination";

export interface Customer {
  id: string;
  name: string;
  phone?: string | null;
  email?: string | null;
  gstin?: string | null;
  pan?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  stateCode?: string | null;
  isActive: boolean;
  createdAt?: string;
}

export type CustomerPayload = Partial<
  Omit<Customer, "id" | "createdAt" | "isActive">
> & {
  name: string;
  isActive?: boolean;
};

const customerAPI = {
  getCustomers: async (params?: {
    pageNo?: number;
    pageSize?: number;
    search?: string;
    isActive?: boolean | string;
  }): Promise<{ data: Customer[]; total: number }> => {
    const response = await api.get("/customers", { params });
    return parsePaginatedList<Customer>(response.data.data);
  },

  getAllCustomers: async (): Promise<Customer[]> => {
    const response = await api.get("/customers/all");
    return asList<Customer>(response.data.data);
  },

  createCustomer: async (data: CustomerPayload): Promise<Customer> => {
    const response = await api.post("/customers", data);
    return response.data.data;
  },

  updateCustomer: async (
    id: string,
    data: Partial<CustomerPayload>
  ): Promise<Customer> => {
    const response = await api.put(`/customers/${id}`, data);
    return response.data.data;
  },

  deleteCustomer: async (id: string): Promise<void> => {
    await api.delete(`/customers/${id}`);
  },
};

export default customerAPI;
